import { render, staticRenderFns } from "./trainingWizardView.vue?vue&type=template&id=072d2cad&scoped=true"
import script from "./trainingWizardView.vue?vue&type=script&lang=js"
export * from "./trainingWizardView.vue?vue&type=script&lang=js"
import style0 from "./trainingWizardView.vue?vue&type=style&index=0&id=072d2cad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072d2cad",
  null
  
)

export default component.exports